import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {AssetUrl} from 'src/app/common/models/ai-reports/shared/assets';
import {AbstractAssetComponent} from '../abstract-asset.component';

@Component({
  selector: 'app-asset-url',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './asset-url.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetUrlComponent extends AbstractAssetComponent<AssetUrl> {}
